import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppSelector';
import { selectUser } from '../../store/features/auth/authSelectors';
import { UserRole } from '../../types/auth.types';

/**
 * Redirects sellers who have not finished onboarding to /seller/onboarding.
 */
export function SellerOnboardingGate({ children }: { children: React.ReactNode }) {
  const user = useAppSelector(selectUser);
  const location = useLocation();

  const isSeller = user?.roles?.includes(UserRole.SELLER);
  const onboardingComplete = Boolean(user?.sellerOnboardingCompletedAt);
  const onOnboarding = location.pathname.startsWith('/seller/onboarding');

  if (isSeller && !onboardingComplete && !onOnboarding) {
    return <Navigate to="/seller/onboarding" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
